import { createSlice } from "@reduxjs/toolkit";

interface SyncDataModalInterface {
    isSyncDataModalOpen: boolean;
}

const initialState: SyncDataModalInterface = {
    isSyncDataModalOpen: false,
};

const syncDataModalSlice = createSlice({
    name: "syncDataModal",
    initialState,
    reducers: {
        setIsSyncDataModalOpen: (state, action) => {
            state.isSyncDataModalOpen = action.payload;
        },
    },
});

export const syncDataModalReducer = syncDataModalSlice.reducer;

export const { setIsSyncDataModalOpen } = syncDataModalSlice.actions;
